import { render, staticRenderFns } from "./StockManagementLite.vue?vue&type=template&id=19c17768&scoped=true"
import script from "./StockManagementLite.vue?vue&type=script&lang=js"
export * from "./StockManagementLite.vue?vue&type=script&lang=js"
import style0 from "./StockManagementLite.vue?vue&type=style&index=0&id=19c17768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c17768",
  null
  
)

export default component.exports